import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol6PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL6;
}

export default Atol6PoiTileEntity;
